import { VCardText } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('crud-show',{attrs:{"title":_vm.title,"open":_vm.open},on:{"close":function($event){return _vm.$emit('close')}}},[_c(VCardText,[_c('stock-transaction-show-data',{attrs:{"item":_vm.item}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }